import React from "react";

import { StyledWrapper } from "./Wrapper.elements";

const Wrapper = ({ children }) => {
  return <StyledWrapper>{children}</StyledWrapper>;
};

export default Wrapper;
